import { Box, Stack, Typography } from "@mui/material";

const border = "1px solid #666";
const backgroundColor = "hsla(250, 86%, 97%, 1)";
const fontSize = "14px";

export const columns = [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "Cost Code ",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "Description",
    header: "Material Description",
    size: 290,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  {
    accessorKey: "Cost (US $)",
    header: "Est. Material Cost $",
    Header: (
      <div>
        <div>Estimated</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  {
    accessorKey: "actual_cost",
    header: "Actual Material Cost $",
    Header: (
      <div>
        <div>Actual</div>
        <div>Material Cost</div>
        <div>($)</div>
      </div>
    ),
    size: 90,
    enableSorting: false,
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => (
      <>
        {cell.getValue() ? (
          Math.round(cell.getValue()) ? (
            <Typography color={"green"}>
              {Math.round(cell.getValue())}
            </Typography>
          ) : (
            <Typography color={"red"}>Not bought yet</Typography>
          )
        ) : (
          <Typography color={"red"}>Not bought yet</Typography>
        )}
      </>
    ),
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
  },
  // {
  //   accessorKey: "Total Manhour",
  //   header: "Total Manhour",
  //   muiTableBodyCellProps: { align: "right" },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   size: 80,
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: "actual_hours",
  //   header: "Actual FAB Hrs",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => (
  //     <>{cell.getValue() ? Math.round(cell.getValue()) : ""}</>
  //   ),
  //   // muiTableHeadCellProps: { align: "center" },
  //   // Cell: ({ cell }) => (<>{cell.getValue()?.split(".")[0]}</>),
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalHours") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 100,
  },
  // ...othercolumns
];

export const columns2 = () => [
  // {
  //   accessorKey: "Components",
  //   header: "Material Code",
  //   size: 120,
  //   enableSorting: false,
  //   // muiTableHeadCellProps: { align: "center" },
  // },
  {
    accessorKey: "costCode",
    header: "Cost Code",
    size: 100,
    enableHiding: false,
    enableSorting: false,
  },
  {
    accessorKey: "description",
    header: "Material Description",
    size: 200,
    enableHiding: false,
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
  },
  // {
  //   accessorKey: "quantity",
  //   header: "Quantity",
  //   Header: (
  //     <div>
  //       <div>Quantity</div>
  //     </div>
  //   ),
  //   size: 50,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  // },

  {
    accessorKey: "Cost (US $)",
    header: "Estimated",
    size: 90,
    enableSorting: false,

    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) =>
          acc + (Number(row.original.estCost * row.original.quantity) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        border,
        borderRight: "none",
        backgroundColor,
        fontSize,
        pt: 2,
      },
    },
    columns: [
      {
        accessorKey: "estQty",
        header: "Qty",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        Cell: ({ row }) => "",
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            backgroundColor,
            fontSize,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
      },
      {
        accessorKey: "estCost",
        header: "Cost",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        Cell: ({ row }) => row.original.estCost * row.original.quantity || "",
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
    ],
  },
  {
    accessorKey: "actual_cost",
    header: "Actual",
    size: 90,
    enableSorting: false,
    AggregatedCell: ({ row }) => {
      const total = row.subRows.reduce(
        (acc, curr) => acc + (Number(row.original.poMaterials?.[0]?.cost) || 0),
        0
      );
      return (
        <Typography color="primary" fontWeight="bold">
          Total: ${Math.round(total)}
        </Typography>
      );
    },
    // muiTableHeadCellProps: { align: "center" },
    Footer: () => (
      <Stack>
        <Box color="warning.main" sx={{ textAlign: "center" }}>
          {/* {getValues("totalMaterialCost") || 0} */}
        </Box>
      </Stack>
    ),
    muiTableHeadCellProps: {
      align: "center",
      sx: {
        border,
        backgroundColor,
        fontSize,
        pt: 2,
      },
    },
    columns: [
      {
        accessorKey: "actualQty",
        header: "Qty",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        Cell: ({ row }) => row.original.quantity || "",
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            backgroundColor,
            fontSize,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            borderLeft: border,
            borderRight: "1px solid rgba(224,224,224,1)",
          },
        },
      },
      {
        accessorKey: "actualCost",
        header: "Cost",
        size: 40,
        enableSorting: false,
        // muiTableBodyCellProps: { align: "right" },
        Cell: ({ row }) => row.original.poMaterials?.[0]?.cost || "",
        muiTableHeadCellProps: {
          align: "center",
          sx: { borderRight: border, backgroundColor, fontSize },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: { borderRight: border },
        },
      },
    ],
  },
  {
    accessorKey: "unit",
    header: "Unit",
    Header: (
      <div>
        <div>Unit</div>
      </div>
    ),
    size: 50,
    enableSorting: false,
    // muiTableBodyCellProps: { align: "right" },
    Cell: ({ row }) => {
      const isPlate = row.original?.description
        ?.toLowerCase()
        .includes("plate");
      const isPipe = row.original?.description?.toLowerCase().includes("pipe");
      const isHead = row.original?.costCode?.toLowerCase().includes("head");

      if (row.original.unit) {
        return row.original.unit;
      } else if (isPipe && !isHead) {
        return "mm";
      } else {
        return "Nos";
      }
    },
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  // {
  //   accessorKey: "Est.FAB HoursHours",
  //   header: "Est.FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Est.</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.totalManHours || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Actual FAB HoursHours",
  //   header: "Actual FAB HoursHours",
  //   Header: (
  //     <div>
  //       <div>Actual</div>
  //       <div>FAB Hours</div>
  //       <div>Hours</div>
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <></>,
  //   AggregatedCell: ({ row }) => {
  //     const total = fabData[row.original["Cost Code "]]?.actual_cost || 0;
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         {total || 0}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  // {
  //   accessorKey: "Weight (lb)",
  //   header: "Weight (lb)",
  //   Header: (
  //     <div>
  //       <div>Weight</div>
  //       <div>(lb)</div>
  //       {/* <div>Hours</div> */}
  //     </div>
  //   ),
  //   size: 90,
  //   enableSorting: false,
  //   muiTableBodyCellProps: { align: "right" },
  //   Cell: ({ cell }) => <>{cell.getValue()}</>,
  //   AggregatedCell: ({ row }) => {
  //     const total = row.subRows.reduce(
  //       (acc, curr) => acc + (Number(curr.original["Weight (lb)"]) || 0),
  //       0
  //     );
  //     return (
  //       <Typography color="primary" fontWeight="bold">
  //         Total: {Math.round(total)}
  //       </Typography>
  //     );
  //   },
  //   // muiTableHeadCellProps: { align: "center" },
  //   Footer: () => (
  //     <Stack>
  //       <Box color="warning.main" sx={{ textAlign: "center" }}>
  //         {/* {getValues("totalMaterialCost") || 0} */}
  //       </Box>
  //     </Stack>
  //   ),
  // },
  {
    accessorKey: "Remarks",
    header: "Remarks",
    enableSorting: false,
    // muiTableHeadCellProps: { align: "center" },
    size: 200,
  },
  // ...othercolumns
];
